class MarketingInput extends HTMLElement {
  connectedCallback() {
    this.acceptsMarketingInput = this.querySelector('[name="customer[accepts_marketing]"]');
    this.interestWrapper = this.querySelector('.marketing-input__interest');
    this.interestInputs = this.querySelectorAll('[name="customer_interest"]');
    this.selectedInterests = [];

    this.acceptsMarketingInput.addEventListener('change', ({ target }) => {
      this.showInterest(target.checked);
    });

    this.interestInputs.forEach((input) => {
      input.addEventListener('change', () => this.setInterest());
    });
  }

  showInterest(marketingAccepted) {
    this.interestWrapper.classList.toggle('closed', !marketingAccepted);
    this.interestWrapper.classList.toggle('open', marketingAccepted);

    this.setInterest(marketingAccepted);
  }

  setInterest(marketingAccepted = this.acceptsMarketingInput.checked) {
    if (!marketingAccepted) {
      this.removeAttribute('interests');
    } else {
      const selectedInterests = Array.from(this.interestInputs)
        .filter((input) => input.checked)
        .map((input) => input.value);

      if (selectedInterests.length === 0) return this.removeAttribute('interests');

      this.setAttribute('interests', selectedInterests);
    }
  }
}

if (!customElements.get('marketing-input')) {
  customElements.define('marketing-input', MarketingInput);
}
